<template>
  <div class="hello">
    <div class="download_banner">
      <li style="overflow: hidden;"></li>
      <div class="download_title">
        <h4><img src="../../assets/images/dzh2.png" width="64px" alt="" />多账户交易终端</h4>
        <div style="display: flex;width: 500px;margin: 0 auto;">
          <a href="/api/upload/JeesMTCAutoUpdate/JeesMTCSetup.exe"
            ><img
              v-show="!show"
              @mouseover="mouseover_img"
              class="btn_img"
              src="../../assets/images/btn01.png"
              alt=""/>
            <img
              @mouseout="mouseout_img"
              v-show="show"
              class="btn_img"
              src="../../assets/images/btn02.png"
              alt=""
          /></a>
          
          <img
            v-show="!show1"
            @mouseover="mouseover_img1"
            class="btn_img"
            src="../../assets/images/userManual.png"
            alt=""
          />
          <!--  @click.stop.prevent="code_show = true" -->
          <img
           
            @click="pushManual()"
            @mouseout="mouseout_img1"
            v-show="show1"
            class="btn_img"
            src="../../assets/images/userManual1.png"
            alt=""
          />
          <!-- <img
            v-show="!show1"
            @mouseover="mouseover_img1"
            class="btn_img"
            src="../../assets/images/Android.png"
            alt=""
          />
          <img
            @click.stop.prevent="code_show = true"
            @click="getQRCode()"
            @mouseout="mouseout_img1"
            v-show="show1"
            class="btn_img"
            src="../../assets/images/Android1.png"
            alt=""
          /> -->
        </div>
      </div>
      <div class="img_box">
        <img class="pcImg" src="../../assets/images/img01.png" alt="" />
        <!-- <img class="pcImg_r" src="../../assets/images/phone.png" alt="" /> -->
      </div>
    </div>
    <div class="msg3" style="padding-top: 250px;position: relative;">
      <div
        class="banner2"
        :style="{
          width: width_,
          display: 'flex',
          height: '540px',
          alignItems: 'center'
        }"
      >
        <div
          class="b_right"
          style="width: 560px;margin-right: 50px;margin-left: 50px;"
        >
          <h2 style="margin-bottom: 30px;font-size: 36px;color: #0a101e;">
            账户分组功能
          </h2>
          <p
            style="font-size: 28px;line-height: 40px;color: #8997ab;font-weight: 300;"
          >
            支持多个账户进行分组管理，设置分组倍率，<br />实现多个账户同时进行批量交易。
          </p>
        </div>
        <div
          class="b_left"
          :style="{
            maxWidth: '492px',
            background: backgroundImage1,
            backgroundSize: '100%',
            flex: '1',
            height: '100%'
          }"
        ></div>
      </div>
    </div>

    <div class="msg2">
      <div
        class="banner2"
        :style="{
          width: width_,
          display: 'flex',
          height: '540px',
          alignItems: 'center'
        }"
      >
        <div
          class="b_left"
          :style="{
            maxWidth: '466px',
            background: backgroundImage2,
            backgroundSize: '100%',

            flex: '1',
            height: '100%'
          }"
        ></div>
        <div
          class="b_right"
          style="width: 560px;margin-right: 50px;margin-left: 150px;"
        >
          <h2 style="margin-bottom: 30px;font-size: 36px;color: #0a101e;">
            自设套利
          </h2>
          <p
            style="font-size: 28px;line-height: 40px;color: #8997ab;font-weight: 300;"
          >
            支持非交易所标准套利合约以外的套利交易。
          </p>
        </div>
      </div>
    </div>
    <div class="msg3" style="position: relative;">
      <div
        class="banner2"
        :style="{
          width: width_,
          display: 'flex',
          height: '540px',
          alignItems: 'center'
        }"
      >
        <div
          class="b_right"
          style="width: 560px;margin-right: 50px;margin-left: 50px;"
        >
          <h2 style="margin-bottom: 30px;font-size: 36px;color: #0a101e;">
            云条件单
          </h2>
          <p
            style="font-size: 28px;line-height: 40px;color: #8997ab;font-weight: 300;"
          >
            提供价格条件单、状态条件单、时间条件单及预埋条件单，类型多样，设置灵活。
          </p>
        </div>
        <div
          class="b_left"
          :style="{
            maxWidth: '492px',
            background: backgroundImage3,
            backgroundSize: '100%',
            flex: '1',
            height: '100%'
          }"
        ></div>
      </div>
    </div>
    <nnav></nnav>
    <div style="position: relative;margin-top: 195px;">
      <foot></foot>
    </div>
    <transition name="el-fade-in-linear">
      <div
        class="wxCode"
        v-show="code_show"
        @click.stop.prevent="code_show = false"
      >
        <div
          class="wxBox"
          style="background-color: #fff;width: 400px;padding-top: 1px;text-align: center;"
          @click.stop.prevent="stop"
        >
          <h2 style="color: #000;margin-top: 20px;">Android</h2>
          <div class="code"><canvas id="QRCode" /></div>
          <h3 style="margin-top: 30px;font-size: 18px;">
            请使用安卓手机浏览器
          </h3>
          <h3 style="font-size: 18px;">扫描图片二维码下载安装</h3>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import foot from "../../components/footer/index";
import nnav from "../../components/nav/index";
import "./style.css";
import QRCode from "qrcode";
export default {
  components: { foot, nnav },
  name: "Tdownload2",
  data() {
    return {
      code_show: false,
      QRCodeMsg: "", // 生成二维码信息
      appUrl: "",
      MHeight: document.documentElement.clientHeight - 50 + "px",
      show: false,
      show1: false,

      width_: "1200px",
      screenWidth: document.body.clientWidth,
      backgroundImage1:
        "url(" + require("@/assets/images/bg/page4.png") + ") no-repeat center",
      backgroundImage2:
        "url(" + require("@/assets/images/bg/page5.png") + ") no-repeat center",
      backgroundImage3:
        "url(" + require("@/assets/images/bg/page6.png") + ") no-repeat center"
    };
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;

    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };

    this.$axios.post("/app/get_new").then(res => {
      // console.log(res);
      this.tokenInvalid(res);
      if (res.data.code == 200) {
        this.appUrl = res.data.data.filePath;
      }
    });
  },
  methods: {
    mouseover_img() {
      this.show = true;
    },
    mouseout_img() {
      this.show = false;
    },
    mouseover_img1() {
      this.show1 = true;
    },
    mouseout_img1() {
      this.show1 = false;
    },
    getQRCode() {
      this.QRCodeMsg = "https://yunsrvwebapi.jeesit.com" + `${this.appUrl}`; // 生成的二维码为URL地址
    },
    pushManual(){
      // window.location.href = '/index/help/faq?type=5';
      window.open(window.location.origin+'/index/help/faq?type=5')
    }
  },
  watch: {
    screenWidth() {
      // console.log(this.screenWidth);
      if (this.screenWidth < 1039 && this.screenWidth > 768) {
        this.width_ = "750px";
      }
      if (this.screenWidth > 1040 && this.screenWidth < 1180) {
        this.width_ = "1040px";
      }
      if (this.screenWidth > 1180) {
        this.width_ = "1200px";
      }
      if (this.screenWidth < 750) {
        this.width_ = "980px";
      }
    },
    QRCodeMsg(val) {
      // 获取页面的canvas
      var msg = document.getElementById("QRCode");
      // 将获取到的数据（val）画到msg（canvas）上
      QRCode.toCanvas(msg, val, function(error) {
        // console.log(error);
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/Tdownload2/index.vue